import { z } from 'zod';
import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
import { hasAtMostDecimalPlaces } from './has-at-most-decimal-places.js';
const { label, max, decimals } = PROMOTION_CREDIT_CONSTRAINTS.amount;
/** A credit's whole-dollar-and-cents value: positive, within the column bound, at most two decimal places. */
export const creditAmountInput = z
    .number({ error: `${label} is required.` })
    .positive(`${label} must be greater than 0.`)
    .max(max, `${label} must be ${max.toLocaleString()} or less.`)
    .refine((value) => hasAtMostDecimalPlaces(value, decimals), {
    message: `${label} can have at most ${decimals} decimal places.`,
});
//# sourceMappingURL=credit-amount-input.js.map